import { getJSON } from "@/utils/fetcher";
import type {
  EventLeaderboardEntry,
  LeaderboardEntry,
} from "@henlo/core-supabase";
import type { HenloDatabase } from "@henlo/core-supabase";

export type TetrisEventRow = HenloDatabase["public"]["Tables"]["tetris_events"]["Row"];

export type ActiveTetrisEvent = TetrisEventRow & {
  timeRemainingSeconds?: number | null;
  timeUntilStartSeconds?: number | null;
};

interface LeaderboardResponse {
  leaderboard: LeaderboardEntry[];
}

interface EventLeaderboardResponse {
  event: TetrisEventRow | null;
  leaderboard: EventLeaderboardEntry[];
}

interface ActiveEventResponse {
  event: ActiveTetrisEvent | null;
  serverTime: string;
}

export async function fetchTopLeaderboard(limit = 1) {
  const { leaderboard } = await getJSON<LeaderboardResponse>("/api/tetris/leaderboard", {
    query: { limit },
    cache: "no-store",
  });
  return leaderboard ?? [];
}

export async function fetchFullLeaderboard(limit = 100) {
  const { leaderboard } = await getJSON<LeaderboardResponse>("/api/tetris/leaderboard", {
    query: { limit },
    cache: "no-store",
  });
  return leaderboard ?? [];
}

export async function fetchActiveTetrisEvent() {
  const { event } = await getJSON<ActiveEventResponse>("/api/tetris/events/active", {
    cache: "no-store",
  });
  return event ?? null;
}

export async function fetchEventLeaderboard(slug: string, limit = 100, offset = 0) {
  const { leaderboard } = await getJSON<EventLeaderboardResponse>(
    `/api/tetris/events/${slug}/leaderboard`,
    {
      query: { limit, offset },
      cache: "no-store",
    },
  );
  return leaderboard ?? [];
}
